export default __webpack_public_path__ + "static/Kuppel_IN7011HD-b2c3813d7eb70ff8578fce0184214470.jpg";